var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Root",class:{ hidden: _vm.loading }},[(_vm.ready)?_c('div',{staticClass:"overflow-x-clip"},[_c('App')],1):(_vm.hasError)?_c('AppError'):_vm._e()],1)}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }